<template>
  <div id="app">
    <router-view/>
    <privacy-notice v-if="showPrivacyNotice" />
  </div>
</template>

<script>
import PrivacyNotice from './components/PrivacyNotice';
import $ from 'jquery';

export default {
  components: {
    'privacy-notice': PrivacyNotice,
  },
  data() {
    return {
      acceptedValue: sessionStorage.getItem("accept"),
    }
  },
  computed: {
    isRestrictedRoute() {
      return this.$route.path.startsWith('/admin') || this.$route.path.startsWith('/auth');
    },
    showPrivacyNotice() {
      return !this.isRestrictedRoute;
    }
  },
  watch: {
    isRestrictedRoute(val) {
      if (val) {
        this.cleanupModal();
      }
    }
  },
  methods: {
    cleanupModal() {
      $('#PrivacyNotice').modal('hide');
      $('body').removeClass('modal-open');
      $('body').css('padding-right', '');
      $('.modal-backdrop').remove();
    },
    checkPrivacyNoticeIfAccepted() {
      if (sessionStorage.getItem("accept")) {
        $('#PrivacyNotice').modal('hide');
      } else {
        $('#PrivacyNotice').modal('show');
      }
    }
  },
  mounted() {
    if (this.isRestrictedRoute) {
      this.cleanupModal();
    } else {
      this.checkPrivacyNoticeIfAccepted();
    }
  }
}
</script>

<style scoped>
* {
  font-family: 'Roboto', "Noto Sans SC", "Open Sans", sans-serif;
}
</style>